import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button, FormField, PasswordInput } from '@/components';
import { AuthLayout } from '@/components/layout/AuthLayout';
import { useResetPassword } from '@/hooks/useAuth';

type FormValues = {
  password: string;
  confirm: string;
};

export function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';

  const { register, handleSubmit, formState, watch } = useForm<FormValues>({
    defaultValues: { password: '', confirm: '' },
  });

  const reset = useResetPassword();

  const onSubmit = handleSubmit(async (values) => {
    if (!token) {
      toast.error('Token inválido');
      return;
    }
    try {
      await reset.mutateAsync({ token, password: values.password });
      toast.success('Senha redefinida com sucesso.');
      navigate('/login');
    } catch (e) {
      toast.error('Não foi possível redefinir a senha.');
    }
  });

  return (
    <AuthLayout>
      <div className="auth-header">
        <h1>Redefinir senha</h1>
        <p>Defina uma nova senha para sua conta.</p>
      </div>

      <form onSubmit={onSubmit} className="auth-form">
        <FormField label="Nova senha" error={formState.errors.password?.message}>
          <PasswordInput
            autoComplete="new-password"
            {...register('password', { required: 'Informe a nova senha', minLength: { value: 8, message: 'Mínimo de 8 caracteres' } })}
          />
        </FormField>

        <FormField label="Confirmar senha" error={formState.errors.confirm?.message}>
          <PasswordInput
            autoComplete="new-password"
            {...register('confirm', {
              required: 'Confirme a senha',
              validate: (v) => v === watch('password') || 'As senhas não coincidem',
            })}
          />
        </FormField>

        <div className="auth-actions">
          <Button type="submit" variant="primary" disabled={reset.isLoading}>
            Salvar
          </Button>
          <button type="button" className="link" onClick={() => navigate('/login')}>
            Voltar
          </button>
        </div>
      </form>
    </AuthLayout>
  );
}
